import { FC, useState } from 'react'

import { TCouponBait } from '~/entities/Coupon'

import { CouponFlowsContext } from './context'

export const CouponFlowsProvider: FC = ({ children }) => {
  const [isBaitVisible, setIsBaitVisible] = useState<Record<TCouponBait['type'], boolean>>({
    selfAvatar: false,
  })

  const [rewardToClaim, setRewardToClaim] = useState<TCouponBait['type'] | undefined>()

  const value = { isBaitVisible, setIsBaitVisible, rewardToClaim, setRewardToClaim }

  return <CouponFlowsContext.Provider value={value}>{children}</CouponFlowsContext.Provider>
}
